// SPDX-License-Identifier: AGPL-3.0-or-later

export function getDisabledRequestHeader(): string | null {
	return null;
}

export function initializeDisabledRequestMetadata(): Promise<void> {
	return Promise.resolve();
}
